import { getScrollStyles } from 'styles/scrollbar.styles';
import { getConditionalObject } from 'utils/data';

export const getWrapperStyles = theme => ({
  display: 'flex',
  flex: 1,
  padding: '24px',
  height: '100%',
  overflow: 'auto',
  ...getScrollStyles(theme).scroll,
});

export const getContentStyles = isDeleted => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '40px',

  ...getConditionalObject(isDeleted, {
    pointerEvents: 'none',
  }),
});

export const borrowersStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flexWrap: 'wrap',
};

export const getBorrowersContainerStyles = ({ isActive }) => ({
  ...borrowersStyles,
  ...getConditionalObject(isActive, {
    cursor: 'pointer',
  }),
});

export const borrowerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const ownersFieldCustomStyles = {
  width: 'fit-content',
  minWidth: 'calc(25% - 16px)',
  maxWidth: '100%',
};

export const borrowerNameStyles = {
  fontSize: '1.6rem',
  fontWeight: 700,
  color: ({ palette }) => palette.text.primary,
};

export const separatorStyles = {
  ...borrowerNameStyles,
  color: ({ palette }) => palette.text.secondary,
};

export const sectionWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};
